<template>
   <!--------------------FINESTRA AGGIUNTA / MODIFICA UTENTE------------------------------------------------>
   <div class="dialog draggable-item bg-light light w-100-sm w-100-md w-75-lg  w-50-xl h-75" id="user_dialog" v-if="user">
      <div class="dialog-title pl-10">
         {{ user.id == null ? $t('Create New User') : user.username }}
         <span class="button square closer" @click="$root.$emit('CLOSEUSERVIEWDIALOG')"></span>
      </div>
      <div class="dialog-content overflow bg-light">
         <ul data-role="tabs" class="bg-light"  data-expand="true" style="z-index: 1;">
            <li><a href="#profile"><span class="mif mif-profile mif-2x"></span>{{ $t("Profile") }}</a></li>
            <li class="no-border" v-if="$root.authObj.id_user == user.id"><a href="#policies"><span class="mif mif-notifications mif-2x"></span> {{ $t("Policies") }}</a></li>
         </ul>
         <!--------------------FINESTRA AGGIUNTA / MODIFICA UTENTE / PROFILE------------------------------------------------>
         <form>
            <div id="profile" class="border border-top bg-white">
               <div class="form-group row bg-light mt-4 mb-4" v-if="this.$root.authObj.id_user == user.id">
                  <div class="p-2">
                     <label>{{ $t("Two Factor Authentication") }}</label><br>
                     <input data-class="ml-3" :disabled="this.$root.authObj.id_user != user.id"
                        data-on="on" data-off="off" @change="toggleTFA()" v-model="startEnabling"
                        type="checkbox" data-role="switch" data-caption-position="right"
                        :data-caption="$t('Enable 2FA')">
                  </div>
                  <div v-if="checkTFA.step1 != null && checkTFA.step2 == null" class="bg-primary border fg-white rounded">
                     <div class="row p-2">
                        <div class="cell-md-6  cel-lg-4 cell-sm-12 text-center">
                           <div class="m-4">
                              <Qrcode :value="checkTFA.step1" />
                              <label>{{ checkTFA.secret }}</label>
                           </div>
                        </div>
                        <div class="cell-md-6 cel-lg-8 cell-sm-12">
                           <div class="mb-3 p-1 text-left pt-6">
                              <label class="h6">
                              {{ $t("Scan the QR code on the page using an app such as Google Authenticator, 2 FAS, Microsoft Authenticator, Twilio Authy.") }}
                              </label>
                           </div>
                           <div class="inline-form">
                              <input maxlength="6" minlength="6" class="input w-100" v-model.trim="user.TFAcode" type="text" :placeholder="$t('Insert Code from Authenticator')" required />
                           </div>
                           <div class="inline-form p-2">
                              <a class="button secondary w-100" :disabled="user.TFAcode == null || user.TFAcode.length < 6"  @click="enableTFA">{{ $t("Enable TFA") }}</a>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <!-- MODiFICA: CASO COMPATIBILITA' CON VECCHI UTENTI DOVE EMAIL DIVERSA DA USERNAME -->
               <!-- APPAIONO SIA CAMPO EMAIL CHE USERNAME MA NON SONO EDITABILI -->
               <div class="form-group row" v-if="user.id != null && user.username != user.email">
                  <label>{{ $t("Username") }}*</label>
                  <input data-role="input"  :disabled="user.id != null" 
                     v-model.trim="user.username" type="email" required data-prepend="<span class='mif-person'></span>" 
                     :readonly="true" @focus="e => e.target.removeAttribute('readonly')"
                     data-default-value=""/>                 
               </div>
               <div class="form-group row" v-if="user.id != null && user.username != user.email">
                  <label>{{ $t("Email") }}*</label>
                  <input data-role="input" :disabled="user.id != null" 
                     v-model.trim="user.email" type="email" required data-prepend="<span class='mif-person'></span>" 
                      :readonly="true" @focus="e => e.target.removeAttribute('readonly')"
                     data-default-value=""  />
                  <div v-if="user.id == null & user.email != ''" class="text-muted mt-1 text-small">
                     <span v-if="!isEmailValid" class="p-1 fg-red">
                     <span class='mif-cross text-bold mr-1'></span>
                     <span>{{ $t("Email is not valid") }}</span>
                     </span>
                  </div>
               </div>
               <!-- ----------------------------------------------------------------------------->
               <!-- MODIFICA: CASO DI NUOVI UTENTI DOVE EMAIL E' UGUALE ALLO USERNAME -->
               <!-- APPARE SOLO CAMPO EMAIL NON EDITABILE, POI IN FASE DI SALVATAGGIO username=email -->
               <div class="form-group row" v-if="user.id != null && user.username == user.email">
                  <label>{{ $t("Username") }}/{{ $t("Email") }} *</label>
                  <input data-role="input" :disabled="user.id != null" 
                     v-model.trim="user.email" type="email" required data-prepend="<span class='mif-person'></span>" 
                      :readonly="true" @focus="e => e.target.removeAttribute('readonly')"
                     data-default-value=""  />
                  <div v-if="user.id == null & user.email != ''" class="text-muted mt-1 text-small">
                     <span v-if="!isEmailValid" class="p-1 fg-red">
                     <span class='mif-cross text-bold mr-1'></span>
                     <span>{{ $t("Email is not valid") }}</span>
                     </span>
                  </div>
               </div>
               <!-- ----------------------------------------------------------------------------->
               <!-- INSERIMENTO: SOLO CAMPO EMAIL POI IN FASE DI SALVATAGGIO username=email ----->
               <div class="form-group row" v-if="user.id == null">
                  <label>{{ $t("Username") }}/{{ $t("Email") }}*</label>
                  <input data-role="input" :disabled="user.id != null" 
                     v-model.trim="user.email" type="email" required data-prepend="<span class='mif-person'></span>" 
                      :readonly="true" @focus="e => e.target.removeAttribute('readonly')"
                     data-default-value=""  />
                  <div v-if="user.id == null & user.email != ''" class="text-muted mt-1 text-small">
                     <span v-if="!isEmailValid" class="p-1 fg-red">
                     <span class='mif-cross text-bold mr-1'></span>
                     <span>{{ $t("Email is not valid") }}</span>
                     </span>
                  </div>
               </div>
               <!-- ----------------------------------------------------------------------------->
               <div class="form-group row">
                  <div class="col-6">
                     <label>{{ $t("Firstname") }}*</label>
                     <input data-role="input" v-model.trim="user.firstname" type="text" required
                        data-prepend="<span class='mif-person'></span>" />
                     
                  </div>
                  <div class="col-6">
                     <label>{{ $t("Lastname") }}*</label>
                     <input data-role="input" v-model.trim="user.lastname" type="text" required
                        data-prepend="<span class='mif-person'></span>" />
                     
                  </div>
               </div>
               <div class="form-group row pb-1">
                  <div class="col-6">
                     <label>{{ $t("User Role") }}</label>
                     <select class="select" @change="onChangeRole()" v-model="selectedRole"
                        :disabled="user.id == $session.getAuth()?.id_user">
                        <!--id==1 -> Super admin-->
                        <option v-for="role in roles" :value="role" v-if="role.id != 1" :key="role.id" >
                           {{ role.name }} 
                        </option>
                     </select>
                  </div>
               </div>
               <div class="form-group row" v-if="user.id == null">
                  <div class="col-12">
                     <input data-class="ml-3" 
                        data-on="on" data-off="off"  v-model="selectAllGroups"
                        type="checkbox" data-role="switch" data-caption-position="right"
                        :data-caption="$t('Assign all groups')">
                  </div>
                  <div class="col-12" v-if="selectAllGroups == false">
                     <label>{{ $t("Allowed Groups") }}</label>
                     <select data-role="select" data-filter="true" multiple  :data-filter-placeholder="$t('Search for groups')" data-cls-selected-item="bg-light border pr-2 rounded"
                                    data-cls-selected-item-remover="bg-transparent border-0 d-flex flex-align-center" id="groupselect" name="ids_groups">
                        <option :selected="user.ids_groups.includes(String(group.id_group))" v-for="group in $session.getGroups()" :value="String(group.id_group)" :key="group.id_group">
                           {{ group.name_group }} 
                        </option>
                     </select>
                  </div>
               </div>
               <div class="form-group row" v-if="user.id != null">
                  <div class="col-12">
                     <label>{{ $t("Current Password") }}</label>
                     <input data-role="input" v-no-autocomplete="'mif-lock'" v-model.trim="user.oldPassword"  type="password" required />
                  </div>
               </div>
               <div class="form-group row">
                  <div class="col-6">
                     <label>{{ $t("New Password") }}<span v-if="user.id == null">*</span></label>
                     <PasswordInfos/>
                     <input data-role="input" v-no-autocomplete="'mif-lock'" v-model.trim="user.password"  type="password" required />
                     
                     <div v-if="user.id == null && user.password != ''" class="text-muted mt-1 text-small">
                        <span v-if="!isPasswordValid" class="p-1 fg-red">
                        <span class='mif-cross text-bold mr-1'></span>
                        <span>{{ $t("Password is not valid") }}</span>
                        </span>
                     </div>
                  </div>
                  <div class="col-6">
                     <label>{{ $t("Retype Password") }}<span v-if="user.id == null">*</span></label>
                     <input data-role="input"  v-no-autocomplete="'mif-lock'" v-model.trim="user.confirmPassword" type="password" required />
                     
                  </div>
               </div>
               <div class="form-group row" v-if="user.id != null">
                  <div class="col-12">
                     <label>{{ $t("Allowed Groups") }}</label>
                     <select data-role="select" :data-filter-placeholder="$t('Search for groups')" data-filter="true" multiple data-cls-selected-item="bg-light border pr-2 rounded"
                                    data-cls-selected-item-remover="bg-transparent border-0 d-flex flex-align-center" id="groupselect" name="ids_groups">
                        <option :selected="user.ids_groups.includes(String(group.id_group))" v-for="group in $session.getGroups()" :value="String(group.id_group)" :key="group.id_group">
                           {{ group.name_group }} 
                        </option>
                     </select>
                  </div>
               </div>
            </div>
         </form>
         <div id="policies" class="border border-top bg-white" v-if="$root.authObj.id_user == user.id && user.policies">
            <div v-if="isPoliciesEmpty" class="text-center p-6">
               <NoDataAvailable :message="$t('No policy available')" />
                <a class="button secondary mr-1" @click="$root.$emit('OPENPOLICYVIEWDIALOG', null, $session.getPCList())">
                    <span class="icon mif-2x mif-add"></span>
                    <span>{{ $t("Add Policy") }}</span>
                </a>
            </div>
            <div v-else class="p-4">
               <!--div class="mb-2">{{ $t('Categories') }}: </div-->
                <h6 class="text-bold mb-4 ml-2">{{ $t("Notification Policies") }}</h6>
               
               <!-- Pill tabs minimal -->
               <div class="d-flex flex-wrap gap-1">
                  <button
                     v-for="(key, idx) in categoryKeys"
                     :key="key"
                     type="button"
                     class="button mr-2 mb-2"
                     :class="{ secondary: policyTypeselected === idx }"
                     @click="policyTypeselected = idx"
                     :aria-pressed="policyTypeselected === idx"
                     >
                  {{ $t(key) }}
                  <span class="ml-2" v-if="categoryStats[key]">
                  {{ categoryStats[key].enabled }}/{{ categoryStats[key].total }}
                  </span>
                  </button>
               </div>
               <!-- Contenuto selezionato -->
               <div class="mt-4">
                  <table class="table w-100 bg-white rounded">
                     <thead>
                        <tr>
                           <th class="text-bold w-60 p-2">{{ $t("Policy name") }}</th>
                           <th class="text-bold text-center p-2">{{ $t("Enabled/Disabled") }}</th>
                        </tr>
                     </thead>
                     <tbody>
                        <tr v-for="policy in selectedPolicies" :key="policy.id">
                           <td class="w-60 va-middle">{{ policy.name }}</td>
                           <td class="text-center">
                              <input type="checkbox"
                                 data-role="switch"
                                 v-model="policy.enabled_notifications"
                                 :title="policy.enabled_notifications ? $t('Enabled') : $t('Disabled')">
                           </td>
                        </tr>
                        <tr v-if="selectedPolicies.length === 0">
                           <td colspan="2" class="text-center p-4 text-muted">
                              {{ $t('No policy available') }}
                           </td>
                        </tr>
                     </tbody>
                  </table>
               </div>
            </div>
            <div class="p-4" v-if="$root.authObj.id_user == user.id && !isPoliciesEmpty">
               <div class="p-2">
                  <h6 class="text-bold">{{ $t("Notification Preferences") }}</h6>
               </div>
               <table class="table">
                  <thead>
                     <tr>
                        <th class="text-center">{{ $t("In App") }}</th>
                        <th class="text-center">{{ $t("Desktop") }} </th>
                        <!--Nascosto perchè momentaneamente non disponibile-->
                        <!--<td class="text-center">{{ $t("Mobile") }} </td>-->
                        <th class="text-center">{{ $t("E-mail") }} </th>
                        <!--Nascosto perchè momentaneamente non disponibile-->
                        <!--<td class="text-center">{{ $t("Whatsapp") }} </td>-->
                     </tr>
                  </thead>
                  <tbody>
                     <tr>
                        <td>
                           <div class="text-center  mb-2">
                              <input type="checkbox"  data-role="switch" :data-on="true" v-model="user.socket_notification">
                           </div>
                        </td>
                        <td>
                           <div class="text-center mb-2">
                              <input type="checkbox" data-caption-position="left" :disabled="pushisActive()" @change="handleWebPushChange()" data-role="switch" data-on="true" v-model="user.webpush_notification" >
                           </div>
                        </td>
                        <!--Nascosto perchè momentaneamente non disponibile-->
                        <!--<td>
                           <div class="text-center mb-2">
                               <input type="checkbox" data-caption-position="left" data-role="switch" data-on="true" v-model="user.push_notification">
                           </div>
                           </td>-->
                        <td>
                           <div class="text-center mb-2">
                              <input type="checkbox" data-caption-position="left" data-role="switch" data-on="true" :disabled="user.email == '' ? 'disabled' : false" v-model="user.email_notification">
                           </div>
                        </td>
                        <!--Nascosto perchè momentaneamente non disponibile-->
                        <!--<td>
                           <div class="text-center mb-2">
                               <input type="checkbox" disabled data-caption-position="left" data-role="switch" data-on="true" v-model="user.whatsapp_notification">
                           </div>
                           
                           </td>-->
                     </tr>
                  </tbody>
               </table>
            </div>
         </div>
         <!--div id="policies" class="border border-top h-100  bg-white" v-if="$root.authObj.id_user == user.id && user.policies">
            <NoDataAvailable :message="$t('No policy available')" v-if="isPoliciesEmpty" />
            
            <div class="row">
                   
                <ul class="sidebar-menu col-4 p-0 pt-5">
                
                    <li v-for="(key, index) in Object.keys(user.policies)"><a class="pl-3" @click="policyTypeselected = index" :class="{ 'ml-5 bg-light pl-3 rounded text-bold': policyTypeselected == index }">{{ key }}</a></li>
                </ul>
                <div v-if="index == policyTypeselected" v-for="(userPolicies, index) in Object.values(user.policies)" class="col-8 p-4">
                    <table class="striped table w-100 bg-white border">
                        <thead class="mb-0">
                            <tr class="mb-3">
                                    
                                <td class="text-bold w-50 p-2">{{ $t("Policy name") }}</td>
                                <td class="text-bold text-center p-2">{{ $t("Enabled") }}/{{ $t("Disabled") }}</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="policy in userPolicies">
                                <td class="w-50 va-middle">
            
                                    {{ policy.name }}
                                </td>
                                <td class="text-center">
                                    <input type="checkbox" data-role="switch" 
                                        v-model="policy.enabled_notifications" 
                                        :title="policy.enabled_notifications ? $t('Enabled') : $t('Disabled')">
                                </td>
                            </tr>
                        </tbody>
            
                    </table>    
                    
                        </div>
                </div>
            </div -->
      </div>
      <div class="dialog-actions">
         <ClientMessageView :commands="['usermethods', 'tfamethods']"/>
         <button v-show="user.id != null" :disabled="$root.authObj.id_user == user.id || user.level == '2'" v-disable-tooltip="$t('Current logged user or default user cannot be delete.')" class="button secondary ml-2" @click="deleteUser(user)">{{ $t("Delete") }}</button>
         <button class="button secondary" :disabled="!saveButton_enable" @click="saveUser" v-disable-tooltip:saveButtonDisabled_message>{{ $t("Save") }}</button>
         <button class="button ml-2" @click="$root.$emit('CLOSEUSERVIEWDIALOG')">{{ $t("Close") }}</button>
      </div>
   </div>
</template>
<script>
import { TFA_MESSAGES } from '../../../utils/messages';
import Qrcode from '../../Qrcode.vue';
import { draggableMixin } from '../../../mixins/draggable-mixin'
import PasswordInfos from '../../utils/PasswordInfos.vue';
import NoDataAvailable from '../../utils/NoDataAvailable.vue';
import ClientMessageView from './ClientMessageView.vue';
import { OneSignalSetup } from '../../../utils/OneSignalSetup';

export default {

    mixins: [draggableMixin],
    components: {
        Qrcode,
        PasswordInfos,
        NoDataAvailable,
        ClientMessageView
    },
    name: "UserDialog",
    data() {
        return {
            policyTypeselected: 0,
            selectAllGroups: false,
            startEnabling: false,
            doPasswordsMatch: false,
            policyTypeselected: 0,

            roles: null,
            selectedRole: null
        }
    },
    props: {
        user: {
            type: Object,
            required: true
        },
        checkTFA: {
            type: Object,
            required: true
        }
    },
    computed: {

        // Stato del bottone Save: { disabled: boolean, message: string }
        saveButtonState() {
            const isEditing=!!(this.user&&this.user.id!=null);      // in modifica: email input disabilitato
            const email=(this.user?.email||'').trim();
            const firstname=(this.user?.firstname||'').trim();
            const lastname=(this.user?.lastname||'').trim();
            const newPwd=this.user?.password||'';
            const confirmPwd=this.user?.confirmPassword||'';
            const oldPwd=this.user?.oldPassword||'';

            // 1) Creazione: username deve essere una email valida
            if (!isEditing) {
                const emailValid=/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
                if (!emailValid) {
                    //this.user.email=email;
                    return { disabled: true, message: this.$t('Enter a valid email address') };
                }
            }
            // (In modifica non imponiamo email valida per retro-compatibilità)

            // 2) Firstname e Lastname obbligatori
            if (!firstname) {
                return { disabled: true, message: this.$t('Firstname is required') };
            }
            if (!lastname) {
                return { disabled: true, message: this.$t('Lastname is required') };
            }

            // 3) Password rules
            if (isEditing) {
                // In modifica: nuova password opzionale, ma se presente → servono i controlli
                if (newPwd) {
                    this.doPasswordsMatch=true;
                    if (!oldPwd) {
                        return { disabled: true, message: this.$t('Enter current password') };
                    }
                    if (!this.isPasswordValid) {
                        return { disabled: true, message: this.$t('Enter a valid password') };
                    }
                    if (newPwd!==confirmPwd) {
                        this.doPasswordsMatch=false;
                        return { disabled: true, message: this.$t('The two passwords do not match') };
                    }
                }
            } else {
                // In creazione: nuova password obbligatoria
                this.doPasswordsMatch=true;
                if (!newPwd) {
                    return { disabled: true, message: this.$t('Enter a password') };
                }
                if (!this.isPasswordValid) {
                    return { disabled: true, message: this.$t('Enter a valid password') };
                }
                if (newPwd!==confirmPwd) {
                    this.doPasswordsMatch=false;
                    return { disabled: true, message: this.$t('The two passwords do not match') };
                }
            }

            return { disabled: false, message: '' };
        },

        // Queste due computed si agganciano al template esistente
        saveButton_enable() {
            return !this.saveButtonState.disabled;
        },
        saveButtonDisabled_message() {
            return this.saveButtonState.message;
        },

        // Già presente nel tuo codice (la riporto per completezza)
        isPasswordValid() {
            const pwd=this.user?.password||'';
            // minuscola, maiuscola, carattere speciale (non spazio), no spazi, 8–50
            return /^(?=.*[a-z])(?=.*[A-Z])(?=.*[^\w\s])(?!.*\s).{8,50}$/.test(pwd);
        },
        isEmailValid() {
            const usr=this.user?.email||'';
            // minuscola, maiuscola, carattere speciale (non spazio), no spazi, 8–50
            return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(usr);
        },

        // chiavi ordinate (sinistra)
        categoryKeys() {
            const p=this.user?.policies||{};
            return Object.keys(p);
        },

        // array di policy per la categoria selezionata (destra)
        selectedPolicies() {
            const values=Object.values(this.user?.policies||{});
            return values[this.policyTypeselected]||[];
        },

        // contatori abilitati/total per badge nel nav
        categoryStats() {
            const p=this.user?.policies||{};
            const stats={};
            Object.keys(p).forEach(k => {
                const arr=Array.isArray(p[k])? p[k]:[];
                const enabled=arr.filter(x => x&&x.enabled_notifications===true).length;
                stats[k]={ enabled, total: arr.length };
            });
            return stats;
        },

        isPoliciesEmpty() {
            const u=this.user;
            const p=u&&u.policies;
            if (!p||typeof p!=='object') return true;

            const keys=Object.keys(p);
            if (keys.length===0) return true;

            const allEmpty=Object.values(p).every(v =>
                Array.isArray(v)? v.length===0:!v
            );
            return allEmpty;
        },
    },
    watch: {
        // se cambiano le policies, seleziona la prima categoria disponibile
        'user.policies': {
            handler(val) {
                const count=Object.keys(val||{}).length;
                if (count===0) this.policyTypeselected=0;
                else if (this.policyTypeselected>=count) this.policyTypeselected=0;
            },
            deep: true
        }
    },
    mounted: function() {
        if(this.user.id){
            //In Iperius Remote, l'oggetto user ha il campo groups come array di id dei gruppi. ma qui si chiama ids_groups
            this.user.ids_groups.update(this.user.groups);
        }
        
        this.roles=this.$session.getRoles();
        this.selectedRole=this.roles.find(r => r.id==this.user.role_id||r.name==this.user.role);
        this.startEnabling=this.user.mfa_enabled;
        this.checkTFA.step1=null;
        this.user.webpush_notification=OneSignal.User.PushSubscription.optedIn;

        OneSignalSetup.addEventListener_Change(
            () => {
                console.info("Subscription changed:", OneSignal.User.PushSubscription.optedIn);
                this.user.webpush_notification=OneSignal.User.PushSubscription.optedIn;
                OneSignalSetup.subscribeUser(this.user.id, this.$i18n.locale);
            }
        );
    },

    methods: {

        pushisActive() {
            return OneSignalSetup.pushIsActive();
        },

        handleWebPushChange() {
            OneSignalSetup.handleWebPushChange();
        },

        async deleteUser(user) {

            var dialogID=Math.floor(100000+Math.random()*900000).toString();
            var dialogTitle="Delete User";
            var dialogContent=this.$t('deleteConfirmation', { 0: user.username });

            var okText="Yes";
            var okClass="mr-2 secondary";
            var okResult=true;

            var cancelText="No";
            var cancelClass="alert";
            var cancelResult=false;

            let self=this;
            this.$root.$on(dialogID, async ok => {
                self.$root.$off(dialogID);
                if (ok) {

                    var ok=await self.$api.deleteUser(user.id, user.username);

                    if (ok) {
                        this.$root.$emit("refreshUsers");
                        this.$root.$emit('CLOSEUSERVIEWDIALOG');
                    }
                }

            });

            //Avvio la richiesta che mi risponderà con un $emit
            this.$root.openDialogActions(dialogID, dialogTitle, dialogContent, okText, okClass, okResult, cancelText, cancelClass, cancelResult)
        },

        async saveUser() {
            let self=this;

            var isNew=self.user.id==null;

            if (isNew&&(!this.isPasswordValid||!this.doPasswordsMatch)) {
                self.$root.toast(this.$t("Invalid password"), "alert");
                return;
            }

            if (!self.selectAllGroups) {
                const selectedGroups=window.Metro.getPlugin($("#groupselect"), 'select').val();
                self.user.ids_groups=Array.isArray(selectedGroups)
                    ? selectedGroups.map(String)
                    : [];
            } else {
                self.user.ids_groups=this.$session.getGroups().map(g => String(g.id_group));
            }

            if (this.user.id==null) { // solo in caso di creazione nuovo utente
                this.user.username=this.user.email;
            }

            var user=isNew
                ? await this.$api.createUser(self.user)
                :await this.$api.editUser(self.user);

            if (user==null) {
                return;
            }

            //Se l'utente modificato è lo stesso che ha effettuato il login, lo devo aggiornare anche nelle informazioni in sessione/local storage
            var authObj=this.$root.authObj;
            if (user.id==authObj.id_user) {
                authObj.firstname=user.firstname;
                authObj.lastname=user.lastname;
                authObj.username=user.username;
                self.$session.setAuth(authObj);
                if (localStorage.getItem("AUTH")!=null) {
                    localStorage.setItem("AUTH", JSON.stringify(authObj));
                };
            }


            this.$root.$emit("refreshUsers");
            this.$root.$emit('CLOSEUSERVIEWDIALOG');
        },

        /*****************************USERS - TFA *************************************************/
        async toggleTFA() {
            var self=this;

            //lo abilito
            if (self.startEnabling) {
                var uri=await this.$api.toggleTFA(self.$root.authObj.access_token);


                const secretRegex=/secret=([^&]+)/;
                const match=uri.match(secretRegex);

                if (match) {
                    const secretValue=match[1];
                    self.checkTFA.secret=secretValue;
                    self.checkTFA.step1=uri;
                } else {
                    this.$root.toast(this.$t(TFA_MESSAGES.NOT_ENABLED), "error");
                }


            } else {
                if (self.user.mfa_enabled) {
                    const dialogID=`disable-tfa-${self.user.id}-${Date.now()}`;

                    this.$root.$once(dialogID, async confirmed => {
                        if (!confirmed) {
                            self.startEnabling=true;
                            return;
                        }

                        const tfaDisabled=await self.$api.disableTFA(self.$root.authObj.access_token);
                        if (tfaDisabled) {
                            self.checkTFA.step1=null;
                            self.user.mfa_enabled=false;
                            self.$root.toast(self.$t(TFA_MESSAGES.DISABLED), "success");
                        } else {
                            self.startEnabling=true;
                            self.$root.toast(self.$t(TFA_MESSAGES.NOT_DISABLED), "alert");
                        }
                    });

                    this.$root.openYesNoDialog(
                        dialogID,
                        this.$t("Two Factor Authentication"),
                        this.$t("Are you sure?"),
                        this.$t("Disable"),
                        this.$t("Close"),
                        "js-dialog-close alert",
                        "js-dialog-close button"
                    );

                } else {
                    self.checkTFA.step1=null;
                }



            }
        },
        async enableTFA() {
            var self=this;

            var esito=await this.$api.enableTFA(self.user.TFAcode);
            if (esito==false) {
                //this.$root.toast(this.$t("TFA_NOT_ENABLED"));
            } else {
                self.checkTFA.step2=true;
                self.user.mfa_enabled=true;
                self.startEnabling=true;

            }
        },

        onChangeRole() {
            this.user.role_id=this.selectedRole.id;
            this.user.role=this.selectedRole.name;
        }

    }
}
</script>
